// extracted by mini-css-extract-plugin
module.exports = {"article":"NoticeItem_article__h_3KE","title":"NoticeItem_title__39v5-","date":"NoticeItem_date__1KTvo"};